import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  viewChild,
  ViewContainerRef,
} from '@angular/core';
import { ScreenViewModule } from '../../core/directives/screen-view/_screen-view.module';
import { DEVICE_SIZE } from '../../core/models/others.model';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'tooltip-icon',
  standalone: true,
  imports: [CommonModule, ScreenViewModule, TooltipModule],
  templateUrl: './tooltip-icon.component.html',
  styleUrl: './tooltip-icon.component.scss',
})
export class TooltipIconComponent implements OnInit {
  @Input() icon?: string = 'info';
  @Input() tooltipStyleClass?: string = '';
  @Input() content?: string;
  @Input() component?: any;
  @Input() template?: TemplateRef<any>;
  @Input() classContainer: string = 'm-l-4';

  DEVICE_SIZE = DEVICE_SIZE;
  vcr = viewChild('dynamicContainer', { read: ViewContainerRef });

  @ViewChild('tooltipButton') tooltipButton!: ElementRef<HTMLButtonElement>;

  focusTooltipButton(): void {
    this.tooltipButton.nativeElement.focus();
  }

  ngOnInit(): void {
    if (this.component) {
      this.vcr()?.createComponent(this.component);
    }
  }
}
